import { VERTICALS } from '../data/verticals';
import VerticalPage from './VerticalPage';

const Gyms = () => <VerticalPage config={VERTICALS['gyms']} />;

export default Gyms;
